import React from "react";
import { Route, Redirect } from "react-router-dom";
import isAuthenticated from "./isAuthenticated";
import { getDashboardUrl } from "../views/Home";

const PrivateRoute = ({ component: Component, ...rest }) => {
  return isAuthenticated ? (
    <Route {...rest} component={(props) => <Component {...props} />} />
  ) : (
    <Redirect to={getDashboardUrl()} />
  );
};

export default PrivateRoute;
